import Skeleton from '@polyai/ui/components/atoms/Skeleton';

import * as Styled from './Header.styled';

const SKELETON_BG = 'rgba(255,255,255,0.1)';
const SKELETON_HIGHLIGHT = 'rgba(255,255,255,0.10)';

const HeaderSkeleton = () => {
  return (
    <Styled.SkeletonWrapper>
      <Styled.Header data-test-id="header-skeleton">
        <Styled.ShimmerContainer>
          <Styled.HeaderLeft>
            <Styled.ProjectSettings
              $isMainNavOpen={false}
              style={{ transform: 'translateX(0)', paddingLeft: 24 }}
            >
              <Skeleton
                borderRadius={4}
                height={20}
                highlightColor={SKELETON_HIGHLIGHT}
                style={{ backgroundColor: SKELETON_BG }}
                width={140}
              />
            </Styled.ProjectSettings>
          </Styled.HeaderLeft>

          <Styled.HeaderRight />
        </Styled.ShimmerContainer>
      </Styled.Header>
      <Styled.ActionHeaderSkeleton>
        <Styled.ShimmerContainer>
          <Skeleton
            borderRadius={4}
            height={24}
            highlightColor={SKELETON_HIGHLIGHT}
            style={{ backgroundColor: SKELETON_BG }}
            width={100}
          />
        </Styled.ShimmerContainer>
      </Styled.ActionHeaderSkeleton>
    </Styled.SkeletonWrapper>
  );
};

export default HeaderSkeleton;
